import { convertToErrorString } from '@lmt/unicorn-shared/app/helpers/form/useErrorHandler';
import clsx from 'clsx';
import React from 'react';
import Lottie from 'react-lottie-wrapper';

import animationData from '@lmt/unicorn-shared/app/animations/rainbow.json';
import styles from './Loading.module.scss';
import i18next from 'i18next';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface Props {
  loading: boolean;
  title?: string;
  containerId?: string;
  children?: React.ReactNode;
  className?: string;
  flex?: boolean;
  error?: any;
  wrapperClassName?: string;
  testId?: string;
  /**
   * If parent element does not fit on the screen, animation may be not visible (it is located in the center of the parent).
   * Use this flag if you want animation to always be in the center of visible area (e.g. Mappings page)
   */
  visibleIfOverflow?: boolean;
}

export const Loading: React.FC<Props> = React.memo(function Loading(props) {
  const loadingStyles = [props.className];
  loadingStyles.push(styles.loadingContainer);
  const loadingTranslation = i18next.t('translation:load.loading', '');
  const title = props.title ?? loadingTranslation;

  return (
    <div
      className={clsx(
        props.flex ? styles.flexContainer : styles.container,
        props.wrapperClassName,
      )}
      data-test-id={props.testId}
    >
      <div
        data-loaded={props.loading}
        className={props.flex ? styles.flexLoadingData : styles.loadingData}
      >
        {props.error ? (
          <h1 className={styles.loading} data-test-id="loading-error">
            {convertToErrorString(props.error)}
          </h1>
        ) : (
          props.children
        )}
      </div>
      {props.loading && !props.error && (
        <div className={clsx(loadingStyles)} data-test-id="loading">
          <div
            className={styles.loading}
            data-visible-if-overflow={props.visibleIfOverflow}
          >
            <div className={styles.row}>
              <Lottie options={defaultOptions} height={20} width={20} />
              {title && <div className={styles.title}>{title}</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
